export default __webpack_public_path__ + "static/media/19.f7d66b56.jpeg";